import {initializeApp} from 'firebase/app';
import {FirebaseConfig} from './constants/firebase';

let app = initializeApp(FirebaseConfig);

export default app;
